export default seconds => new Promise(resolve => setTimeout(resolve, seconds * 1000));



// WEBPACK FOOTER //
// src/utils/delay.js